export type RecommendedChipsTypes = {
  skillRecommends?: boolean
  searchBoost?: number
  courseRecommends?: boolean | number
  partnerRecommends?: boolean | number
  partnerPremium?: boolean | number
}

export enum RecommendedChipsEnum {
  PARTNER_RECOMMENDED = 'PARTNER_RECOMMENDED',
  COURSE_RECOMMENDED = 'COURSE_RECOMMENDED',
  PREMIUM_PARTNER = 'PREMIUM_PARTNER'
}

export const mapRecommendedChipsFields = (data: RecommendedChipsTypes) => ({
  courseRecommends: (data?.searchBoost ?? 0) > 0,
  partnerRecommends: data?.skillRecommends ?? false,
  partnerPremium: data?.partnerPremium ?? false
})
